import React, { useState } from "react";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import EditBranch from "./Editbranch";
import { useBranches, updateBranch } from "services/branchService";
import { ActiveCell, SignatureCell } from "../GridComponents";
import { EditCommandCell } from "../GridComponents";
import { toast } from "react-toastify";
import styles from "../Settings.module.scss";
import { GridLoader } from "components/GridLoader";

const BranchNameCell = (props) => {
  return (
    <td>
      <div className="d-flex flex-column">
        <div>
          <span>{props.dataItem.branchName}</span>
        </div>
        <div className={styles[`addressLines`]}>
          <span>{props.dataItem.address.line1}</span>
          <span>{props.dataItem.address.line2}</span>
        </div>
      </div>
    </td>
  );
};

const BranchesList = () => {
  const [openForm, setOpenForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { data: branches, loading } = useBranches();

  const enterEdit = (item) => {
    setOpenForm(true);
    setEditItem(item);
  };

  const handleSubmit = async (event) => {
    setIsSubmitting(true);
    try {
      const data = {
        branchName: event.branchName,
        branchCode: event.branchCode,
        address: {
          line1: event.address.line1,
          line2: event.address.line2,
          town: event.address.town,
          state: event.address.state,
          postcode: event.address.postcode,
          country: event.address.country,
        },
        active: event.active,
      };

      const result = await updateBranch(event.branchId, data);
      if (result.success) {
        toast.success("Branch updated successfully");
        setOpenForm(false);
      } else {
        toast.error("Failed to update branch");
      }
    } catch (error) {
      toast.error("An error occurred while updating branch");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancelEdit = () => setOpenForm(false);

  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );
  return (
    <div className="settings-grid h-100">
      <Grid data={branches} style={{ height: "100%" }}
        loader={
          <div style={{ height: "50px" }}>
            <GridLoader />
          </div>
        }
        showLoader={loading}>
        <GridNoRecords>
          {loading ? (
            <span></span>
          ) : (
            branches && branches?.length === 0 && "No branches found"
          )}
        </GridNoRecords>
        <Column
          width="80"
          field="branchName"
          title=" "
          cell={(props) => <SignatureCell {...props} />}
        />
        <Column
          field="branchName"
          title="Name"
          cell={BranchNameCell}
          width="200"
        />
        <Column field="branchCode" title="Code" width="90" />
        <Column field="address.town" title="Town" width={120} />
        <Column field="address.state" title="State" width={120} />
        <Column field="address.postcode" title="Postcode" width={130} />
        <Column field="address.country" title="Country" width={150} />
        <Column title="Active" cell={ActiveCell} width="80" />
        <Column title=" " cell={MyEditCommandCell} width="80" />
      </Grid>

      {openForm && (
        <EditBranch
          cancelEdit={handleCancelEdit}
          onSubmit={handleSubmit}
          item={editItem}
          isSubmitting={isSubmitting}
        />
      )}
    </div>
  );
};

export default BranchesList;
